var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4 w-full flex justify-center"},[_c('Button',{attrs:{"disabled":_vm.allLoaded,"loading":_vm.loading},on:{"click":_vm.handler}},[_vm._v(" Load More... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }